"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRedux = require("react-redux");

var _reactBootstrap = require("react-bootstrap");

var _DetailsAccordion = _interopRequireDefault(require("./DetailsAccordion"));

var _NothingSelected = _interopRequireDefault(require("./NothingSelected"));

var _ToolBar = _interopRequireDefault(require("./ToolBar"));

var _Properties = _interopRequireDefault(require("../Properties/Properties"));

var _FieldOrderPanel = _interopRequireDefault(require("./FieldOrder/FieldOrderPanel"));

require("../../../css/SideBar.css");

function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
      t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}

function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };

  var t = _getRequireWildcardCache(r);

  if (t && t.has(e)) return t.get(e);
  var n = {
    __proto__: null
  },
      a = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var u in e) {
    if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
      var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
      i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
  }

  return n["default"] = e, t && t.set(e, n), n;
}

var SideBar = function SideBar(_ref) {
  var onLastSave = _ref.onLastSave,
      appHeight = _ref.appHeight,
      selectedQuestion = _ref.selectedQuestion,
      lastSaved = _ref.lastSaved;

  var _useState = (0, _react.useState)(false),
      showPropertiesFieldAccordion = _useState[0],
      setShowPropertiesFieldAccordion = _useState[1];

  var _useState2 = (0, _react.useState)(true),
      showFormFieldAccordion = _useState2[0],
      setShowFormFieldAccordion = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      showFieldOrderAccordion = _useState3[0],
      setShowFieldOrderAccordion = _useState3[1];

  (0, _react.useEffect)(function () {
    setShowPropertiesFieldAccordion(!!selectedQuestion);
  }, [selectedQuestion]);
  (0, _react.useEffect)(function () {
    if (onLastSave) {
      onLastSave(lastSaved);
    }
  }, [lastSaved]);
  var containerStyle = {
    height: appHeight + "px"
  };
  return (
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.Container, {
      className: "sidebar scroller mb-0 ml-0 mr-0 pt-2 mh-100 overflow-auto pr-3 pl-3",
      style: containerStyle,
      "data-cy": "sidebar"
    },
    /*#__PURE__*/
    _react["default"].createElement(_DetailsAccordion["default"], {
      isOpen: showFormFieldAccordion,
      accordionToggle: function accordionToggle() {
        return setShowFormFieldAccordion(!showFormFieldAccordion);
      },
      accordionContent:
      /*#__PURE__*/
      _react["default"].createElement(_ToolBar["default"], null),
      accordionName: "Form Fields"
    }),
    /*#__PURE__*/
    _react["default"].createElement("div", {
      style: {
        height: '8px'
      }
    }), selectedQuestion ?
    /*#__PURE__*/
    _react["default"].createElement(_DetailsAccordion["default"], {
      isOpen: showPropertiesFieldAccordion,
      accordionToggle: function accordionToggle() {
        return setShowPropertiesFieldAccordion(!showPropertiesFieldAccordion);
      },
      accordionContent:
      /*#__PURE__*/
      _react["default"].createElement(_Properties["default"], null),
      accordionName: "Field Details"
    }) :
    /*#__PURE__*/
    _react["default"].createElement(_NothingSelected["default"], null),
    /*#__PURE__*/
    _react["default"].createElement("div", {
      style: {
        height: '8px'
      }
    }),
    /*#__PURE__*/
    _react["default"].createElement(_DetailsAccordion["default"], {
      isOpen: showFieldOrderAccordion,
      accordionToggle: function accordionToggle() {
        return setShowFieldOrderAccordion(!showFieldOrderAccordion);
      },
      accordionContent:
      /*#__PURE__*/
      _react["default"].createElement(_FieldOrderPanel["default"], null),
      accordionName: "Field Order"
    }))
  );
};

SideBar.defaultProps = {
  appHeight: window.innerHeight,
  selectedQuestion: null,
  lastSaved: ''
};
SideBar.propTypes = process.env.NODE_ENV !== "production" ? {
  onLastSave: _propTypes["default"].func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  selectedQuestion: _propTypes["default"].objectOf(_propTypes["default"].any),
  lastSaved: _propTypes["default"].string,
  appHeight: _propTypes["default"].number
} : {};

var mapStateToProps = function mapStateToProps(state) {
  return {
    selectedQuestion: state.selectedQuestion.selectedQuestion,
    lastSaved: state.questionSet.lastSave
  };
};

var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps)(SideBar);